import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Input, Radio, Table, TableColumnsType, Checkbox } from 'antd'
import { useEffect } from 'react'
import { AgendamentoModel } from '../../../../components/models/Models'
import { ConsultarStore } from '../ConsultarStore'
import { formatDate, getNumbers, hasLetters } from '../../../../components/common/Utils'
import { BooleanIcon } from '../../../../components/common/BooleanIcon'
import Button from 'antd/es/button'
import { isValid as isCpfValid } from '@fnando/cpf'
import { StatusDetranIcon } from '../../../../components/agendamentos/StatusDetranIcon'

interface Aluno {
  key: any
  turma: any
  cpf: any
  nome: any
  agendadoDetran: any
  importadoSuperPratico: any
  dataCriacao: any
}

type TFilter = '' | 'SEM_TURMA' | 'COM_PENDENCIAS' | 'AGUARDANDO_TURMA'

export const Alunos = () => {
  const {
    SearchBar,
    SearchInput,
    FilterGroup,
    getColumns,
    filterAlunos,
    searchAlunos,
    alunoToTableRecord,
  } = Alunos
  const { agendamentos } = ConsultarStore.useState()

  const [filter, setFilter] = useState<TFilter[]>([])
  const [searchValue, setSearchValue] = useState('')

  const filteredAlunos = React.useMemo(() => {
    let matchedAlunos = filterAlunos(agendamentos, filter)
    matchedAlunos = searchAlunos(matchedAlunos, searchValue)
    return matchedAlunos.map((a: AgendamentoModel, i: number) => alunoToTableRecord(i, a))
  }, [agendamentos, filter, searchValue])

  return (
    <div>
      <SearchBar>
        <SearchInput
          name="socioAdminCpf"
          placeholder="Nome ou CPF"
          value={searchValue}
          onChange={(e: any) => setSearchValue(e.target.value)}
          size="large"
        />

        <FilterGroup onChange={(c: any) => setFilter(c)}>
          <Checkbox value="SEM_TURMA">Aluno(s) não agendados</Checkbox>
          <Checkbox value="COM_PENDENCIAS">Aluno(s) com pendência(s)</Checkbox>
        </FilterGroup>
      </SearchBar>

      <Table pagination={false} columns={getColumns()} dataSource={filteredAlunos} />
    </div>
  )
}
Alunos.SearchBar = styled.div`
  display: flex;
  align-items: center;
  background-color: #e6eef5;
  padding: 15px;
  column-gap: 5px;
`
Alunos.SearchInput = styled(Input)`
  font-size: '13pt';
  width: 300px;
  text-transform: uppercase;
`
Alunos.FilterGroup = styled(Checkbox.Group)`
  display: flex;
`
Alunos.BtnAgendar = ({ cpf }: { cpf: string }) => {
  return (
    <a href={`${location.origin}/agendamentos/agendar/${cpf}`}>
      <Button>Agendar</Button>
    </a>
  )
}
Alunos.getColumns = () => {
  return [
    {
      key: 'turma',
      dataIndex: 'turma',
      align: 'center',
      fixed: true,
      title: 'Turma',
    },
    {
      key: 'cpf',
      dataIndex: 'cpf',
      align: 'left',
      fixed: true,
      title: 'CPF',
    },
    {
      key: 'nome',
      dataIndex: 'nome',
      align: 'left',
      fixed: true,
      title: 'Nome',
    },
    {
      key: 'cfcDestino',
      dataIndex: 'cfcDestino',
      align: 'left',
      fixed: true,
      title: 'CFC Destino',
    },
    {
      key: 'tipoCurso',
      dataIndex: 'tipoCurso',
      align: 'center',
      fixed: true,
      title: 'Tipo Curso',
    },
    {
      key: 'agendadoDetran',
      dataIndex: 'agendadoDetran',
      align: 'center',
      fixed: true,
      title: 'Agendado no Detran',
    },
    {
      key: 'importadoSuperPratico',
      dataIndex: 'importadoSuperPratico',
      align: 'center',
      fixed: true,
      title: 'Importado no Super Prático',
    },
    {
      key: 'motivo',
      dataIndex: 'motivo',
      align: 'center',
      fixed: true,
      title: 'Motivo do cancelamento ou pendência no Detran',
    },
    {
      key: 'dataCriacao',
      dataIndex: 'dataCriacao',
      align: 'center',
      fixed: true,
      title: 'Data emissão boleto',
    },
  ] as TableColumnsType<object>
}
Alunos.filterAlunos = (agendamentos: AgendamentoModel[], filters: TFilter[]): any => {
  if (!agendamentos) return []

  filters.map((f) => {
    switch (f) {
      case 'SEM_TURMA':
        agendamentos = agendamentos.filter((a) => !a.turma)
        break
      case 'COM_PENDENCIAS':
        agendamentos = agendamentos.filter(
          (a) =>
            ['PENDENTE', 'AGUARDANDO'].includes(a.statusDetran || '') ||
            !a.dataImportacaoSuperPratico
        )
        break
    }
  })

  return agendamentos
}
Alunos.searchAlunos = (agendamentos: AgendamentoModel[], searchValue: string) => {
  const removeAccents = (value: any) => value?.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

  if (!agendamentos) return []

  if (!hasLetters(searchValue)) {
    const cpf = getNumbers(searchValue)
    if (cpf.length === 11 && isCpfValid(cpf))
      return agendamentos?.filter((a: any) => getNumbers(a.cpf) === cpf)
  }

  return agendamentos?.filter((a) => {
    const searchedValue = removeAccents(a!.nome).toUpperCase()
    return searchedValue.indexOf(removeAccents(searchValue.toUpperCase())) !== -1
  })
}
Alunos.alunoToTableRecord = (key: any, agendamento: AgendamentoModel) => {
  const { BtnAgendar } = Alunos

  const turma = agendamento.turma ? (
    `${formatDate(agendamento?.turma?.dataInicio, 'dd/MM')} - ${agendamento?.turma?.modalidade}`
  ) : (
    <BtnAgendar cpf={agendamento?.cpf} />
  )

  return {
    key: key,
    turma,
    cpf: agendamento.cpf,
    nome: agendamento.nome,
    cfcDestino: agendamento.cfcDestino?.fantasia,
    tipoCurso: agendamento.tipoCurso,
    agendadoDetran: <StatusDetranIcon status={agendamento?.statusDetran} />,
    importadoSuperPratico: <BooleanIcon condition={!!agendamento.dataImportacaoSuperPratico} />,
    motivo: (
      <strong style={{ color: '#f14545' }}>
        <em>{agendamento.motivo}</em>
      </strong>
    ),
    dataCriacao: formatDate(agendamento.createdAt),
  }
}
